var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmazonNoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 21,
    viewBox: "0 0 29 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5714_49835)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.710938,
    y: 0.838867,
    width: 28,
    height: 20,
    fill: "#19BFBF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7103 18.1722C18.7604 18.1722 22.0436 14.889 22.0436 10.8389C22.0436 6.7888 18.7604 3.50555 14.7103 3.50555C10.6602 3.50555 7.37695 6.7888 7.37695 10.8389C7.37695 14.889 10.6602 18.1722 14.7103 18.1722ZM20.6737 11.5056C20.4261 13.7447 18.9464 15.6125 16.9276 16.4159C17.5777 15.0918 17.9575 13.3669 18.0306 11.5056H20.6737ZM16.6959 11.5056C16.5986 13.7546 16.0114 15.7423 15.0958 16.8267C14.9683 16.8348 14.8398 16.8389 14.7103 16.8389C14.5808 16.8389 14.4522 16.8348 14.3248 16.8267C13.4092 15.7423 12.822 13.7546 12.7246 11.5056H16.6959ZM11.39 11.5056C11.4631 13.3669 11.8429 15.0918 12.493 16.4159C10.4741 15.6125 8.99443 13.7447 8.74691 11.5056H11.39ZM12.7246 10.1722H16.6959C16.5986 7.92317 16.0114 5.93546 15.0958 4.85107C14.9683 4.84299 14.8398 4.83889 14.7103 4.83889C14.5808 4.83889 14.4522 4.84299 14.3248 4.85107C13.4092 5.93546 12.822 7.92317 12.7246 10.1722ZM12.493 5.26191C11.8429 6.58594 11.4631 8.31086 11.39 10.1722H8.74691C8.99443 7.93305 10.4741 6.06526 12.493 5.26191ZM20.6737 10.1722H18.0306C17.9575 8.31086 17.5777 6.58593 16.9276 5.26191C18.9464 6.06525 20.4261 7.93305 20.6737 10.1722Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5714_49835"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.710938,
    y: 0.838867,
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonNoneIcon);
export default __webpack_public_path__ + "static/media/amazon-none-icon.26173367aed658f27398c8e9609767a8.svg";
export { ForwardRef as ReactComponent };